<template>
  <v-container class="shopStartPage">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>


      <v-toolbar-title class="pageTitle">
        Impressum
      </v-toolbar-title>
    </v-toolbar>
      <v-divider class="headerDivider"/>

    <div class="imprintWrapper">
      <v-card class="imprintCard">
        <p>
        <strong>
          Verantwortlich für den Inhalt dieser Seite
          <br>
        </strong>
          Julius Graf GmbH & Co. KG <br/>
          Frankenstraße 26 <br/>
          97616 Salz
        </p>

        <p>
          <strong>
            Handelsregister:
            <br>
          </strong>
          Registergericht Schweinfurt: HRA 10203
        </p>

        <p>
          <strong>
            diese vertreten durch:
            <br>
          </strong>
          Graf Verwaltungs GmbH
        </p>

        <p>
          <strong>
            Handelsregister:
            <br>
          </strong>
          Registergericht Schweinfurt: HRB 8343
        </p>

        <p>
          <strong>
            Telefon:
          </strong>
            +49 (0) 9771 / 2458
          <br>
          info@grafgruppe.de
          <br>
          </p>
        <p>
          <strong>
            Anfragen zum Datenschutz:
            <br>
          </strong>
            datenschutz@grafgruppe.de
        </p>
        <p>&nbsp;</p>

        <h2>Geschäftsführer:</h2>
        <p>
          Johannes Graf
        </p>


        <h2>Verantwortlich i.S.v. §6 MdStV:</h2>
        <p>Johannes Graf <br/>
          Julius Graf GmbH & Co. KG <br/>
          Frankenstraße 26 <br/>
          97616 Salz
        </p>


        <h2>Haftungsausschluss:</h2>
        <h2>
          <strong>
            Inhalt des Onlineangebotes
            <br>
          </strong>
        </h2>
        <p>
          Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Autor, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens des Autors kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt.
        </p>
        <p>
          Alle Angebote sind freibleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.
        </p>
        <h2>
          <strong>
            Verweise und Links
          </strong>
        </h2>
        <p>
          Bei direkten oder indirekten Verweisen auf fremde Webseiten (“Hyperlinks”), die außerhalb des Verantwortungsbereiches des Autors liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall in Kraft treten, in dem der Autor von den Inhalten Kenntnis hat und es ihm technisch möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger Inhalte zu verhindern.
        </p>
        <p>
          Der Autor erklärt hiermit ausdrücklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die aktuelle und zukünftige Gestaltung, die Inhalte oder die Urheberschaft der verlinkten/verknüpften Seiten hat der Autor keinerlei Einfluss. Deshalb distanziert er sich hiermit ausdrücklich von allen Inhalten aller verlinkten /verknüpften Seiten, die nach der Linksetzung verändert wurden. Diese Feststellung gilt für alle innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie für Fremdeinträge in vom Autor eingerichteten Gästebüchern, Diskussionsforen, Linkverzeichnissen, Mailinglisten und in allen anderen Formen von Datenbanken, auf deren Inhalt externe Schreibzugriffe möglich sind.
        </p>
        <p>
          Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der über Links auf die jeweilige Veröffentlichung lediglich verweist.
        </p>
        <h2>
          <span>
            Urheber- und Kennzeichenrecht
          </span>
        </h2>
        <p>
          Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen.
          Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer.
        </p>
        <p>
          Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind!
          Das Copyright für veröffentlichte, vom Autor selbst erstellte Objekte bleibt allein beim Autor der Seiten. Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung des Autors nicht gestattet.
        </p>
        <h2>
          <strong>
            Datenschutz
          </strong>
        </h2>
        <p>
          Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe persönlicher oder geschäftlicher Daten (Emailadressen, Namen, Anschriften) besteht, so erfolgt die Preisgabe dieser Daten seitens des Nutzers auf ausdrücklich freiwilliger Basis. Die Inanspruchnahme und Bezahlung aller angebotenen Dienste ist – soweit technisch möglich und zumutbar – auch ohne Angabe solcher Daten bzw. unter Angabe anonymisierter Daten oder eines Pseudonyms gestattet. Die Nutzung der im Rahmen des Impressums oder vergleichbarer Angaben veröffentlichten Kontaktdaten wie Postanschriften, Telefon- und Faxnummern sowie Emailadressen durch Dritte zur Übersendung von nicht ausdrücklich angeforderten Informationen ist nicht gestattet. Rechtliche Schritte gegen die Versender von sogenannten Spam-Mails bei Verstössen gegen dieses Verbot sind ausdrücklich vorbehalten.
        </p>
        <h2>
          <strong>
            Google Analytics
          </strong>
        </h2>
        <p>
          Diese Website benutzt Google Analytics, einen Werbeanalysedienst der Google Inc. ("Google"). Google Analytics verwendet sog. "Cookies", Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie ermöglichen. Die durch den Cookie erzeugten Informationen über Ihre Benutzung dieser Website (einschließlich Ihrer IP-Adresse) wird an einen Server von Google in den USA übertragen und dort gespeichert. Google wird diese Informationen beutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten für die Websitebetreiber zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen zu erbringen. Auch wird Google diese Informationen ggf. an Dritte übertragen, sofern dies gesetzlich vorgeschrieben oder soweit Dritte diese Daten im Auftrag von Google verarbeiten. Google wird in keinem Fall Ihre IP-Adresse mit anderen Daten von Google in Verbindung bringen.
        </p>
        <p>
          Sie können die Installation der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern: wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall ggf. nicht sämtliche Funktionen dieser Website vollumfänglich nutzen können. Durch die Nutzung dieser Website erklären Sie sich mit der Bearbeitung der über Sie erhobenen Daten durch Google in der zuvor beschriebenen Art und Weise und zu dem zuvor benannten Zweck einverstanden.
        </p>
        <h2>
          <strong>
            Alternative Streitbeilegung gemäß Art. 13 Abs. 2 ADR-RL und § 36 VSBG
          </strong>
        </h2>
        <p>
          Zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind wir nicht verpflichtet und nicht bereit.
        </p>

      </v-card>
      <igros-logo></igros-logo>
      <div class="bottomFiller"/>
    </div>
    <side-navigation/>
    <cart-drawer/>
    <inventory-drawer/>
    <scanner-dialog/>
  </v-container>
</template>

<script>
import {mapActions} from 'vuex'
import router from "@/router"
import IgrosLogo from "@/assets/logo/igrosLogo";
import SideNavigation from "@/app/global/sideNavigation";
import CartDrawer from "@/app/cart/cartDrawer";
import ScannerDialog from "@/app/scanner/scannerDialog";
import InventoryDrawer from "@/app/inventory/inventoryDrawer";

export default {
  name: "imprint",
  components: {InventoryDrawer, ScannerDialog, CartDrawer, SideNavigation, IgrosLogo},
  methods: {
    ...mapActions({
      setHeaderVisibility: 'setHeaderVisibility'
    }),

    goBack() {
      router.go(-1)
    }
  },

  mounted() {
    this.setHeaderVisibility(false)
  }
}
</script>

<style>

</style>
